import { render, staticRenderFns } from "./DialogoChat.vue?vue&type=template&id=61353810&lang=pug&"
import script from "./DialogoChat.vue?vue&type=script&lang=js&"
export * from "./DialogoChat.vue?vue&type=script&lang=js&"
import style0 from "./DialogoChat.vue?vue&type=style&index=0&lang=sass&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports